import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  model,
  ModelSignal,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appShowFullText]',
})
export class ShowFullTextDirective {
  appShowFullText: ModelSignal<string> = model.required<string>();
  placement: ModelSignal<'top' | 'left' | 'bottom' | 'right'> = model.required<
    'top' | 'left' | 'bottom' | 'right'
  >();
  mode: ModelSignal<'delete' | 'default'> = model<'delete' | 'default'>(
    'default'
  );
  exitCondition: ModelSignal<boolean> = model<boolean>(false);

  delay = 250;
  tooltip!: HTMLElement | null;

  offset = 10;

  private renderer = inject(Renderer2);
  constructor(private el: ElementRef<HTMLParagraphElement>) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!!this.tooltip) return;
    if (this.exitCondition()) return;

    this.show();
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (!this.tooltip) return;
    if (this.exitCondition()) return;

    this.hide();
  }

  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-' + this.mode() + '-show');
  }

  hide() {
    this.renderer.removeClass(
      this.tooltip,
      'ng-tooltip-' + this.mode() + '-show'
    );
    window.setTimeout(() => {
      if (!document.body || !this.tooltip) return;
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }, this.delay);
  }

  create() {
    this.tooltip = this.renderer.createElement('span');
    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.appShowFullText())
    );

    this.renderer.appendChild(document.body, this.tooltip);

    this.renderer.addClass(this.tooltip, 'ng-tooltip-' + this.mode() + '');
    this.renderer.addClass(
      this.tooltip,
      `ng-tooltip-${this.mode()}-${this.placement()}`
    );

    this.renderer.setStyle(
      this.tooltip,
      '-webkit-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-moz-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-o-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      'transition',
      `opacity ${this.delay}ms`
    );
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip!.getBoundingClientRect();

    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let top: number;
    let left: number;

    if (this.placement() === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    } else if (this.placement() === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    } else if (this.placement() === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    } else {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }

    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
